// Inventory Management Permissions

export const INVENTORIES_INDEX = 69;
export const INVENTORIES_SHOW = INVENTORIES_INDEX;
export const INVENTORIES_CREATE = 70;
export const INVENTORIES_EDIT = 71;
export const INVENTORIES_DELETE = 72;
export const INVENTORIES_RESTORE = 1397;

// Inventory Quantity Types
export const INVENTORY_QUANTITY_TYPES_INDEX = 73;
export const INVENTORY_QUANTITY_TYPES_CREATE = 74;
export const INVENTORY_QUANTITY_TYPES_EDIT = 75;
export const INVENTORY_QUANTITY_TYPES_DELETE = 76;
export const INVENTORY_QUANTITY_TYPES_RESTORE = 1386;

// Inventory Movements
export const INVENTORIES_MOVEMENTS_INDEX = 138;
// Returns are movements; one list permission covers both.
export const INVENTORIES_MOVEMENTS_RETURNS_INDEX = INVENTORIES_MOVEMENTS_INDEX;

// Inventory Categories
export const INVENTORY_CATEGORIES_INDEX = 198;
export const INVENTORY_CATEGORIES_CREATE = 199;
export const INVENTORY_CATEGORIES_EDIT = 200;
export const INVENTORY_CATEGORIES_DELETE = 201;
export const INVENTORY_CATEGORIES_RESTORE = 1387;

export const WITHDRAW_REQUESTS_INDEX = 322;
